import { Box, Divider, Flex } from "@chakra-ui/layout";
import { Fragment } from "react";
import { colors, CSSPixelValue, HStack, VStack } from "goi_common";
import getPriceText from "@/utils/getPriceText";
import { ceilPrice } from "@/utils/ceilPrice";

export interface DetailItemProps {
  title: string;
  currentTab: string;
  sum: number | undefined;
  isNotLocale?: boolean;
  results: {
    [key: string]: {
      detail?: string;
      charge?: number | string;
      has_alpha?: boolean;
    };
  };
  padding?: CSSPixelValue;
}

function DetailItem({
  title,
  currentTab,
  sum,
  isNotLocale = false,
  results,
  padding = "32px 20px",
}: DetailItemProps) {
  const parseDetailPrice = (charge: number | string | undefined, sum: number | undefined) => {
    if (typeof charge === "number" && sum) {
      return Math.round((charge / sum) * 100) + "%";
    }
    if (typeof charge === "string") {
      return charge;
    }
    if (charge === 0) {
      return "-";
    }
    return "-";
  };

  return (
    <VStack background={colors.gray900} className="white">
      {title === currentTab && (
        <VStack padding="20px">
          <Flex className="subtitle3" justifyContent="space-between">
            <div>{title} 예상 비용</div>
            <HStack alignItems="center" gap={3}>
              {sum === 0 ? (
                "-"
              ) : (
                <>
                  <div className="caption_12_m">약</div>
                  <div>{getPriceText(ceilPrice(sum, 100000), false, isNotLocale)}</div>
                </>
              )}
            </HStack>
          </Flex>
          <div style={{ marginBottom: "8px" }} />
          <Divider color="white" />
          {Object.entries(results).map(([key, { detail, charge, has_alpha }], i) => (
            <Fragment key={key}>
              <div style={{ marginBottom: "12px" }} />
              <Flex
                className="subtitle_14_b"
                color={i === 0 ? "#E2452B" : "white"}
                justifyContent="space-between"
                alignItems="center"
              >
                <Box flexShrink={0} padding="0 10px 0 0">
                  {key}
                </Box>
                <Box height="0.8px" width="100%" overflow="hidden">
                  <Box
                    width="100%"
                    borderTopWidth="3px"
                    borderStyle="dashed"
                    borderColor={colors.gray600}
                  />
                </Box>
                <Flex alignItems="center" flexShrink={0} padding="0 0 0 10px">
                  <span>{parseDetailPrice(charge, sum)}</span>
                </Flex>
              </Flex>
            </Fragment>
          ))}
        </VStack>
      )}
    </VStack>
  );
}

export default DetailItem;
